export default {"src":"/developer/_next/static/media/close_white.9309bf19.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};